var map = {
	"./arrow-left.png": "a398",
	"./arrow-right.png": "3846",
	"./background.jpg": "1100",
	"./badges/app-store-badge.png": "4d03",
	"./badges/play-store-badge.png": "9b45",
	"./banner-background.png": "cf1d",
	"./banner-phone.png": "4428",
	"./blogAssets/blogImages/2021-esignature.png": "c961",
	"./blogAssets/blogImages/advantages-of-ocr.png": "288d",
	"./blogAssets/blogImages/cant-find-shopping-receipts.png": "be4f",
	"./blogAssets/blogImages/how-to-use-scanner-image.png": "7cdd",
	"./blogAssets/blogImages/how-to-use-scanner.png": "57fb",
	"./blogAssets/blogImages/increase-productivity.png": "b474",
	"./blogAssets/blogImages/keep-docs-secure.png": "2723",
	"./blogAssets/blogImages/organize-business-cards.png": "1d75",
	"./blogAssets/blogImages/scanner-for-business-hr.png": "461a",
	"./blogAssets/blogImages/support-homeschool.png": "b3ef",
	"./blogAssets/blogImages/what-is-ocr.png": "96a0",
	"./blogAssets/blogPages": "b633",
	"./blogAssets/blogPages.js": "b633",
	"./blogAssets/blogPages/advantages-of-ocr-technology.html": "d995",
	"./blogAssets/blogPages/cant-find-your-business-cards.html": "6173",
	"./blogAssets/blogPages/cant-find-your-shopping-receipts.html": "da7b",
	"./blogAssets/blogPages/how-to-use-scanner-plus.html": "2434",
	"./blogAssets/blogPages/importance-of-digital-signature-in-remote-life.html": "48e0",
	"./blogAssets/blogPages/increase-your-productivity-in-school.html": "b8ac",
	"./blogAssets/blogPages/keep-all-your-documents-secure.html": "d156",
	"./blogAssets/blogPages/scanner-plus-for-business-and-hr-management.html": "461e",
	"./blogAssets/blogPages/support-homeschool.html": "2db1",
	"./blogAssets/blogPages/what-is-ocr.html": "dbce",
	"./burger-menu-background.jpg": "8789",
	"./cookie-logo.png": "cced",
	"./document-back.png": "d987",
	"./error-404.png": "5fc4",
	"./featurePages/page-camera.png": "1beb",
	"./featurePages/page-edit.jpg": "56bb",
	"./featurePages/page-ocr.jpg": "e99d",
	"./featurePages/page-scan.jpg": "5c5b",
	"./featurePages/page-share.jpg": "43b8",
	"./featurePages/page-signature.jpg": "7718",
	"./featurePages/page-testimonials.jpg": "46fd",
	"./featurePages/page-translate.jpg": "2a9f",
	"./file-indicator.png": "09cf",
	"./fileToolbox/download.png": "8600",
	"./fileToolbox/navigator-left.png": "6ca9",
	"./fileToolbox/navigator-right.png": "e1f3",
	"./fileToolbox/view-continuous-active.png": "926f",
	"./fileToolbox/view-continuous.png": "9c40",
	"./fileToolbox/view-fit-active.png": "fbe6",
	"./fileToolbox/view-fit.png": "4271",
	"./fileToolbox/view-fullscreen.png": "66ed",
	"./fileToolbox/view-grid.png": "6b98",
	"./fileToolbox/zoom-in.png": "cea0",
	"./fileToolbox/zoom-out.png": "dea8",
	"./grid-overlay-corner.png": "c2fb",
	"./homepage-background.jpg": "dafa",
	"./homepagePapers/paper1.png": "5c0a",
	"./homepagePapers/paper2.png": "9e50",
	"./homepagePapers/paper3.png": "a174",
	"./icons/icon-android.svg": "1ee8",
	"./icons/icon-apple.svg": "aaa1",
	"./icons/icon-arrow-backward.svg": "cb7f",
	"./icons/icon-arrow-forward.svg": "10b0",
	"./icons/icon-check.svg": "dc7b",
	"./icons/icon-download.svg": "ae39",
	"./icons/icon-edit-dark.svg": "10c9",
	"./icons/icon-edit.svg": "d5ef",
	"./icons/icon-mobile-menu.svg": "c005",
	"./icons/icon-moile-menu.svg": "9898",
	"./icons/icon-ocr-dark.svg": "49e2",
	"./icons/icon-ocr.svg": "87d7",
	"./icons/icon-quote.svg": "8d75",
	"./icons/icon-scan-dark.svg": "290f",
	"./icons/icon-scan.svg": "f2a9",
	"./icons/icon-scanner-logo.svg": "b528",
	"./icons/icon-search.svg": "6819",
	"./icons/icon-share-dark.svg": "11ca",
	"./icons/icon-share.svg": "bcda",
	"./icons/icon-signature-dark.svg": "ae95",
	"./icons/icon-signature.svg": "dab2",
	"./icons/icon-translate-dark.svg": "1fd8",
	"./icons/icon-translate.svg": "c3e6",
	"./mobile-banner-background.jpg": "4c18",
	"./mobile-camera-frame.png": "be6e",
	"./mobile-homepage-background.jpg": "9517",
	"./more-arrow.png": "f6b3",
	"./no-search-results.png": "c5d5",
	"./phone-frame.png": "6097",
	"./scanner-logo.png": "0dc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";